import { render, staticRenderFns } from "./LockTimeForm.vue?vue&type=template&id=f1ff5966&scoped=true"
import script from "./LockTimeForm.vue?vue&type=script&lang=js"
export * from "./LockTimeForm.vue?vue&type=script&lang=js"
import style0 from "./LockTimeForm.vue?vue&type=style&index=0&id=f1ff5966&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ff5966",
  null
  
)

export default component.exports